module.exports = __webpack_public_path__ + "img/Documents copy.8ea7f722.svg";